import "@formatjs/intl-numberformat/polyfill"
import {
  getMovementsSolucionare
} from "helpers/blopsleads_helper"
import React, { useEffect, useRef, useState } from "react"
import { Container, Spinner } from "reactstrap"
import toastr from "toastr"
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import BarChart from "./dashboad-process-components/BarChart"
import CardApolices from "./dashboad-process-components/CardApolices"
import CardClassificacao from "./dashboad-process-components/CardClassificacao"
import CardOportunidades from "./dashboad-process-components/CardOportunidades"
import CardProcesso from "./dashboad-process-components/CardProcesso"
import CardPublications from "./dashboad-process-components/CardsPublications"
import MiniWidgetProcesso from "./dashboad-process-components/MiniWidgetProcesso"

function LeadsList() {
  //meta title
  document.title = "Cockpit"

  const [processosSolucionare, setProcessosSolucionare] = useState({})
  const [movements, setMovements] = useState({})
  const [metrics, setMetrics] = useState({})
  const [publications, setPublications] = useState({})
  const [loading, setLoading] = useState(true)
  const [loadingMetrics, setLoadingMetrics] = useState(true)
  const [loadingPublications, setLoadingPublications] = useState(true)
  const [loadingMove, setLoadingMove] = useState(true)

  // const fetchSolucionareRegister = async () => {
  //   try {
  //     const response = await getProcessSolucionare()
  //     setProcessosSolucionare(response)
  //   } catch (error) {
  //     toastr.error("Erro ao carregar os processos")
  //   }
  // }
  const fetchSolucionareMoviments = async () => {
    try {
      const resMovements = await getMovementsSolucionare()
      setMovements(resMovements)
    } catch (error) {
      toastr.error("Erro ao carregar as movimentações")
    }
  }

  // const fetchSolucionarePublications = async () => {
  //   try {
  //     const resPublications = await getMetricsPublications()
  //     setPublications(resPublications)
  //   } catch (error) {
  //     toastr.error("Erro ao carregar as publicações")
  //   }
  // }

  // const fetchSolucionareMetrics = async () => {
  //   try {
  //     const metrics = await getMetricsProcesses()
  //     setMetrics(metrics)
  //   } catch (error) {
  //     toastr.error("Erro ao carregar as informações")
  //   }
  // }

  useEffect(() => {
    const loadData = async () => {
      setLoadingMove(true)
      await fetchSolucionareMoviments()
      setLoadingMove(false)
      setLoading(false)
    }
    loadData()
  }, [])

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const movimentacoesProcessos = [
    {
      title: "Andamentos - até o momento",
      total: movements?.andamentos?.total || 0,
      newTodayCount: movements?.andamentos?.totalToday || 0,
      newMonthCount: movements?.andamentos?.monthlyCounts[0]?.total || 0,
      icon: "bx bx-run",
      color: "success",
    },
    {
      title: "Agrupadores",
      total: movements?.agrupadores?.total || 0,
      newTodayCount: movements?.agrupadores?.totalToday || 0,
      newMonthCount: movements?.agrupadores?.monthlyCounts[0]?.total || 0,
      icon: "bx bx-folder",
      color: "success",
    },
    {
      title: "Dependências",
      total: movements?.dependencias?.total || 0,
      newTodayCount: movements?.dependencias?.totalToday || 0,
      newMonthCount: movements?.dependencias?.monthlyCounts[0]?.total || 0,
      icon: "bx bx-link",
      color: "success",
    },
    {
      title: "Documentos",
      total: movements?.documentos?.total || 0,
      newTodayCount: movements?.documentos?.totalToday || 0,
      newMonthCount: movements?.documentos?.monthlyCounts[0]?.total || 0,
      icon: "bx bx-file",
      color: "success",
    },
  ]

  const dadosProcessos = {
    total: processosSolucionare?.totalLeads || 0,
    hoje: processosSolucionare?.todayCount || 0,
    semana: processosSolucionare?.weekCount || 0,
    mes: processosSolucionare?.monthCount || 0,
  }

  return (
    <React.Fragment>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center min-vh-100"
          style={{ minHeight: "80vh" }}
        >
          <Spinner
            color="primary"
            style={{
              width: "3rem",
              height: "3rem",
            }}
          />
        </div>
      ) : (
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Analítico" breadcrumbItem="Cockpit" />

            {/* <DashboardCards /> */}

            <CardProcesso processos={dadosProcessos} loading={loading} />
            <CardClassificacao />
            <CardOportunidades />
            <CardApolices />
            {/* <Unrated metrics={metrics} loading={loadingMetrics} /> */}
            <CardPublications />
            <MiniWidgetProcesso
              movimentacoes={movimentacoesProcessos}
              loading={loadingMove}
            />

            <div>
              <BarChart movements={movements} />
            </div>
          </Container>
        </div>
      )}
    </React.Fragment>
  )
}

export default LeadsList
